const moeda = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const numero = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 });
const percentual = new Intl.NumberFormat('pt-BR', { style: 'percent', maximumFractionDigits: 1 });
const umaCasa = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 });

export const formatarMoeda = (valor: number) => moeda.format(valor);
export const formatarNumero = (valor: number) => numero.format(valor);
export const formatarPercentual = (fracao: number) => percentual.format(fracao);

const UNIDADES = ['B', 'KB', 'MB', 'GB', 'TB'];

export function formatarTamanho(bytes: number) {
  let valor = bytes;
  let indice = 0;
  while (valor >= 1024 && indice < UNIDADES.length - 1) {
    valor /= 1024;
    indice++;
  }
  return `${umaCasa.format(valor)} ${UNIDADES[indice]}`;
}

/** Extensão do nome do arquivo, em minúsculas e sem o ponto ("" quando não houver). */
export function extensaoDe(nomeArquivo: string) {
  const posicao = nomeArquivo.lastIndexOf('.');
  return posicao > 0 ? nomeArquivo.slice(posicao + 1).toLowerCase() : '';
}
